function devIgnoreHiding() {
   const v = window.WCCP_DEV_MODE && window.WCCP_DEV_MODE.ignoreHiding;
   return v === true || v === 1 || v === '1' || v === 'true';
}

function devBlockAutoSelectSimple() {
    return !!(
        window.WCCP_DEV_MODE &&
        window.WCCP_DEV_MODE.blockAutoSelectionSimple
    );
}

function devLog(type, payload) {
  if (!window.WCCP_DEV_MODE?.showDebug) return;
  window.WCCP_DEV_CONSOLE?.log(type, payload);
}

function stepHasVariationSelect(stepEl) {
  if (!stepEl) return false;
  // If there is at least one select variation on the step, we consider the step "variable"
  return !!stepEl.querySelector('.wccp-variation-select');
}

// TRUE only for simple steps (without variation select)
function devBlockAutoSelectSimpleForStep(stepEl) {
  return devBlockAutoSelectSimple() && !stepHasVariationSelect(stepEl);
}


function disableOptionsForDev(stepEl) {
  if (!stepEl) return;

  qsa(selFor(CLASSES.option), stepEl).forEach(opt => {
    opt.classList.add('wccp-dev-disabled');
    opt.style.pointerEvents = 'none';
    opt.style.opacity = '0.5';
  });

  qsa('.wccp-variation-select', stepEl).forEach(sel => {
    sel.disabled = true;
    sel.style.opacity = '0.6';
  });
}

function showDevOptionsPreview(stepEl, compId) {
  if (!stepEl) return;
  if (stepEl.querySelector('.wccp-dev-options-preview')) return;

  const comp =
    STATE?.data?.components?.find(c => Number(c.id) === Number(compId));
  if (!comp || !Array.isArray(comp.products)) return;

  const effects =
  window.WCCP_DEBUG?.scenarioEffectsByComponent?.[compId] || [];


  const wrap = document.createElement('div');
  wrap.className = 'wccp-dev-options-preview';
  wrap.style.cssText = `
    margin-top:12px;
    padding:10px;
    border:1px dashed #c00;
    background:#fff7f7;
    opacity:0.9;
  `;

  wrap.innerHTML = `
    <div style="font-size:13px;color:#900;margin-bottom:6px">
      DEV MODE: options hidden by scenarios (preview only)
    </div>
    <ul style="list-style:none;padding:0;margin:0"></ul>
  `;

  const ul = wrap.querySelector('ul');

  if (effects.length) {
  const reason = document.createElement('div');
  reason.style.cssText = `
    margin-top:8px;
    font-size:12px;
    color:#700;
  `;
  reason.innerHTML = `
    <div style="font-weight:bold;margin-bottom:4px">
      Hidden by scenarios:
    </div>
    <ul style="margin:0;padding-left:16px">
      ${effects.map(e => `
        <li>
          <code>${e.scenarioId}</code>
          <span style="opacity:0.8">(${e.effect})</span>
        </li>
      `).join('')}
    </ul>
  `;
  wrap.appendChild(reason);
}


  comp.products.forEach(p => {
    const li = document.createElement('li');
    li.style.cssText = `
      display:flex;
      align-items:center;
      gap:8px;
      margin-bottom:6px;
      opacity:0.5;
      pointer-events:none;
    `;

    li.innerHTML = `
        <img src="${p.thumbnail_url || p.thumb || ''}"
            style="width:40px;height:40px;object-fit:cover;border:1px solid #ccc">
        <div style="display:flex;flex-direction:column;line-height:1.2">
            <span>${p.name || '—'}</span>
            <span style="font-size:11px;color:#666">
            product-id: <code>${p.product_id}</code>
            </span>
        </div>
        `;


    ul.appendChild(li);
  });

  const target =
    stepEl.querySelector('.component_selections') || stepEl;

  target.appendChild(wrap);
}


function getStepDebugStatus(stepEl, idx) {
    if (!stepEl) return null;

    const cid  = Number(stepEl.dataset.item_id);
    const step = Number(stepEl.dataset.step);

    const allowedSet =
        computeAllowedByComponent().get(cid) || new Set();

    // 1. Scenario-hidden
    if (!allowedSet.size) {
        return {
            step,
            component_id: cid,
            status: 'scenario-hidden'
        };
    }

    // 2. Auto-skipped
    if (
        allowedSet.size === 1 &&
        stepEl.style.display === 'none'
    ) {
        return {
            step,
            component_id: cid,
            status: 'auto-skipped'
        };
    }

    // 3. Visible
    return {
        step,
        component_id: cid,
        status: 'visible'
    };
}


const goNext = async (fromIndex) => {
    const steps = qsa(selFor(CLASSES.step), root);

    for (let i = fromIndex + 1; i < steps.length; i++) {

        // ===== DEV: STEP STATUS =====
        if (devIgnoreHiding()) {
            const info = getStepDebugStatus(steps[i], i);
            if (info) {
                window.WCCP_DEV_CONSOLE?.log(
                    'STEP_STATUS',
                    info
                );
            }
        }

        if (isHiddenStep(steps[i])) {
            /*** DEBUG ***/
            // window.WCCP_TIMING.logHiddenStep(steps[i].dataset.item_id);
            /*** END DEBUG ***/
            await processHiddenStep(steps[i]);
            continue;
        }


        if (await autoSelectAndSkipIfSingle(steps[i], i)) {
            continue;
        }

        if (stepIsEffectivelyVisible(steps[i])) {
            if (devIgnoreHiding()) {
                const cid = Number(steps[i].dataset.item_id);
                const allowedSet = computeAllowedByComponent().get(cid) || new Set();

                if (!allowedSet.size) {
                    if (!steps[i].querySelector('.wccp-dev-hidden-note')) {
                        const note = document.createElement('div');
                        note.className = 'wccp-dev-hidden-note';
                        note.textContent = 'DEV MODE: Component hidden by scenarios';
                        note.style.cssText =
                            'padding:10px;background:#fee;border:1px dashed #c00;margin-bottom:10px';
                        steps[i].prepend(note);
                    }

                    disableOptionsForDev(steps[i]);

                    showDevOptionsPreview(steps[i], cid);
                }
            }

            if (window.WCCP_DEV_MODE?.debug?.componentSkip) {
                const cid = Number(steps[i].dataset.item_id);
                const allowedSet = computeAllowedByComponent().get(cid) || new Set();

                if (!allowedSet.size) {
                    devLog('FILTER_COMPONENT_SKIP', {
                        component_id: cid,
                        step: Number(steps[i].dataset.step),
                        reason_code: 'scenario_hidden',
                        reason: 'Component hidden by scenarios',
                        allowed_product_ids: [],
                        effects:
                            window.WCCP_DEBUG?.scenarioEffectsByComponent?.[cid] || [],
                        source: 'stepIsEffectivelyVisible'
                    });
                }
            }

            if (window.WCCP_DEV_MODE?.debug?.appliedFilters) {
                const cid = Number(steps[i].dataset.item_id);
                const allowedSet = computeAllowedByComponent().get(cid) || new Set();

                const backendRules =
                    (window.WCCP_FILTERING_RULES || [])
                    .filter(r =>
                        r &&
                        r.enabled &&
                        String(r.component_id) === String(cid)
                    );

                window.WCCP_DEV_CONSOLE?.log("STEP_APPLIED_FILTERS", {
                    // step: Number(steps[i].dataset.step),
                    component_id: cid,

                    // frontend result
                    allowed_product_ids: [...allowedSet],
                    scenario_effects:
                    window.WCCP_DEBUG?.scenarioEffectsByComponent?.[cid] || [],

                    // backend context
                    backend_filtering: {
                    is_filterable: backendRules.length > 0,
                    rules: backendRules.map(r => ({
                        rule_id: r.id || null,
                        component_id: r.component_id,
                        enabled: r.enabled,
                        type: r.type || 'unknown'
                    }))
                    },

                    selected_upstream: JSON.parse(JSON.stringify(STATE.selected))
                });
                }


              if (window.WCCP_DEV_MODE?.debug?.triggeredScenarios) {
                const cid = Number(steps[i].dataset.item_id);
                const stepNum = Number(steps[i].dataset.step);

                const matched = getStableMatchedScenarios();
                const effects =
                window.WCCP_DEBUG?.scenarioEffectsByComponent?.[cid] || [];

                devLog('TRIGGERED_SCENARIOS', {
                    step: stepNum,
                    component_id: cid,
                    scenario_ids: matched.map(s => s.id || s.scenario_id || s.name),
                    effects
                });
            }

            if (window.WCCP_DEV_MODE?.debug?.allowedComponents) {
                const cid = Number(steps[i].dataset.item_id);
                const stepNum = Number(steps[i].dataset.step);

                const allowedSet =
                    computeAllowedByComponent().get(cid) || new Set();

                devLog('ALLOWED_COMPONENTS_SUMMARY', {
                    // step: stepNum,
                    component_id: cid,

                    base_products:
                        window.WCCP_DEBUG?.baseProductsByComponent?.[cid] || [],

                    allowed_products: [...allowedSet],

                    allowed_count: allowedSet.size,

                    scenario_effects:
                        window.WCCP_DEBUG?.scenarioEffectsByComponent?.[cid] || [],

                    selected_upstream:
                        JSON.parse(JSON.stringify(STATE.selected))
                });
            }


            steps[fromIndex].style.display = 'none';

            suspendNarrowing(() => {
                steps[i].style.display = 'block';
                updateStepNavButtons(steps[i]);
                disableNextButtonIfNoSelection(steps[i]);
            });

            await narrowIfNeededForStep(steps[i]);
            await ensureVariationsForStep(steps[i]);
            updateStepNavButtons(steps[i]);
            disableNextButtonIfNoSelection(steps[i]);
            prefetchFiltersForStep(steps[i]);
            return;
        }

    }
};


    const goPrev = async (fromIndex) => {
        const steps = qsa(selFor(CLASSES.step), root);

        for (let i = fromIndex - 1; i >= 0; i--) {

            if (isHiddenStep(steps[i])) continue;

            const single = await (async () => {
                const compId = Number(steps[i].dataset.item_id);
                const allowed = computeAllowedByComponent().get(compId) || new Set();
                const opts = qsa(selFor(CLASSES.option), steps[i]).filter(o =>
                    allowed.has(Number(o.dataset.productId))
                );
                return opts.length === 1;
            })();
            if (single && !isLastStep(i)) continue;

            if (stepIsEffectivelyVisible(steps[i])) {
                steps[fromIndex].style.display = 'none';
                suspendNarrowing(() => {
                    steps[i].style.display = 'block';
                    updateStepNavButtons(steps[i]);
                });
                await narrowIfNeededForStep(steps[i]);
                await ensureVariationsForStep(steps[i]);
                updateStepNavButtons(steps[i]);
                prefetchFiltersForStep(steps[i]);
                return;
            }
        }

    };


    const variationLabel = (attrs) => {
        const obj = attrs && typeof attrs === 'object' ? attrs : {};
        const items = Object.entries(obj).map(([k, v]) => {
            const key = String(k).replace(/^attribute_/, '').replace(/^pa_/, '');
            return `${key}: ${String(v).replace(/-/g, ' ')}`;
        });
        return items.join(', ') || 'Variation';
    };

    function autoSelectSingleVariation(selectEl) {
        if (!selectEl) return;

        if (selectEl.value) return;

        const stepEl = selectEl.closest('[data-item_id]');
        const compId = stepEl ? Number(stepEl.dataset.item_id) : null;
        if (compId && window.STATE?.selectedVariants?.[compId]) return;

        const valid = Array.from(selectEl.options).filter(o => o.value && o.value !== '');

        if (valid.length === 1) {
            selectEl.value = valid[0].value;

            if (compId && window.STATE) {
                window.STATE.selectedVariants = window.STATE.selectedVariants || {};
                window.STATE.selectedVariants[compId] = Number(valid[0].value);
            }

            if (window.WCCP_DEV_MODE?.debug?.variationSkip) {
                devLog('AUTO_VARIATION_SELECTED', {
                component_id: compId,
                variation_id: Number(valid[0].value),
                reason: 'single variation available',
                source: 'autoSelectSingleVariation',
                has_backend_filtering: isFilteredComponent(compId)
                });
            }

            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    const renderStep = (component, stepIndex) => {
        const step = document.createElement('div');
        step.className = CLASSES.step;
        step.dataset.step = String(stepIndex + 1);
        step.dataset.item_id = String(component.id);
        step.style.display = stepIndex === 0 ? 'block' : 'none';

        if (component.component_type === 'accessories_step') {
            step.classList.add('accessories-step');
            return renderAccessoriesStepContent(step, component);
        }

        step.innerHTML = `
  <div class="wccp-step-nav">
    <button type="button" class="wccp-step-nav__btn wccp-prev-btn">
      <span class="wccp-step-nav__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
      Previous
    </button>
    <div class="wccp-step-nav__spacer"></div>
    <button type="button" class="wccp-step-nav__btn wccp-next-btn">
      Next
      <span class="wccp-step-nav__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
    </button>
  </div>

  <div class="${CLASSES.stepTitleWrap}">
    <h2 class="${CLASSES.stepTitleH2}">
      <span class="${CLASSES.stepTitleText}">
        <span class="${CLASSES.stepTitle}">${component.title}</span>
      </span>
    </h2>
  </div>
  <div id="component_${component.id}_inner" class="${CLASSES.inner}">
    <div class="${CLASSES.selections}">
      <p class="${CLASSES.sectionTitle}"><label class="select_label">Available options:</label></p>
      <div class="${CLASSES.options}">
        <div class="${CLASSES.optionsInner}">
          <ul class="${CLASSES.ul}" style="list-style:none"></ul>
        </div>
      </div>
    </div>
  </div>
`;


        const ul = step.querySelector('ul');
        const frag = document.createDocumentFragment();

        (component.products || []).forEach((p, idx) => {
            const li = document.createElement('li');
            li.className = CLASSES.li + (idx === 0 ? ' first' : '');

            const opt = document.createElement('div');
            opt.className = CLASSES.option;
            opt.dataset.componentId = String(component.id);
            opt.dataset.productId = String(p.product_id);

            const needsDropdown = Boolean(p.is_variable) && Array.isArray(p.variations) && p.variations.length > 0;

            const selectHtml = needsDropdown
                ? `<div style="margin-top:8px">
       <select class="wccp-variation-select" data-component-id="${component.id}" data-product-id="${p.product_id}">
         <option value="">— Select Variation —</option>
         ${p.variations.map(v => `
           <option value="${v.variation_id}">
             ${variationLabel(v.attributes)}
           </option>
         `).join('')}
       </select>
     </div>`
                : '';

            const labelsHtml = Array.isArray(p.labels) && p.labels.length
                ? `<div class="wccp-labels-wrap">
                ${p.labels
                    .filter(l => l.enabled)
                    .sort((a, b) => a.priority - b.priority)
                    .map(l => `
                        <span class="wccp-label" style="background:${l.bg};color:${l.fg}">
                            ${l.icon ? `<img src="${l.icon}" alt="" width="14" height="14" style="vertical-align:middle;margin-right:4px;">` : ''}
                            ${l.title}
                        </span>
                    `)
                    .join('')}
              </div>`
                : '';

            opt.innerHTML = `
    ${labelsHtml}
  <div class="${CLASSES.imgWrap}">
    <img src="${p.thumbnail_url || p.thumb || ''}" width="300" height="300" loading="lazy" decoding="async" alt="${(p.name||'').replace(/"/g,'&quot;')}">
  </div>
  <div class="${CLASSES.nameWrap}">
    <span>${p.name || ''}</span>
    ${selectHtml}
  </div>
`;


            li.appendChild(opt);
            frag.appendChild(li);
        });

        ul.appendChild(frag);
        qsa('.wccp-variation-select', step).forEach(autoSelectSingleVariation);
        return step;
    };

    function isLastStep(idx) {
        const steps = qsa(selFor(CLASSES.step), root);

        for (let i = idx + 1; i < steps.length; i++) {
            if (stepIsEffectivelyVisible(steps[i])) {
                return false;
            }
        }

        return true;
    }


    let WCCP_FINALIZING = false;

    async function finalizeLastStep(stepEl, idx) {
        const devIgnore = devIgnoreHiding();

        // if (devIgnore) {
        //     if (!window.WCCP_ALLOW_FINALIZE) {
        //         console.warn("[WCCP] FINALIZE BLOCKED — no user click");
        //         return;
        //     }
        //     window.WCCP_ALLOW_FINALIZE = false;
        // }

    // if (!isLastStep(idx)) return;
    if (!isLastStep(idx) && !devIgnore) return;

    if (WCCP_FINALIZING) return;
    WCCP_FINALIZING = true;

    stepEl.style.display = 'none';

    try {
        if (typeof addCompositeToCart === 'function') {
            await addCompositeToCart();
        } else if (typeof buildAddToCartPayload === 'function') {
            const p = buildAddToCartPayload();
            if (p && p.product_id && Object.keys(p.components || {}).length) {
                const target = (window?.cdi_door_filter_ajax?.cart_url) || '/cart/';
                window.location.href = target;
            }
        }
    } catch (err) {
        console.error('Auto finalize (last step) failed:', err);
    } finally {
        WCCP_FINALIZING = false;
    }
}

function disableNextButtonIfNoSelection(stepEl) {
    if (!stepEl) return;

    const nextBtn = stepEl.querySelector('.wccp-next-btn');
    if (!nextBtn) return;

    const compId = Number(stepEl.dataset.item_id);

    if (compId === STATE.accessories_step_id) {
        nextBtn.disabled = false;
        return;
    }

    const allowedSet = computeAllowedByComponent().get(compId) || new Set();

    if (devIgnoreHiding() && !allowedSet.size) {
        nextBtn.disabled = false;
        return;
    }

    const hasSelection = !!STATE.selected[compId];
    nextBtn.disabled = !hasSelection;
}


function bindStepClicksFor(stepEl) {
    const idx = Number(stepEl.dataset.step) - 1;
    const prevBtn = stepEl.querySelector('.wccp-prev-btn');
    const nextBtn = stepEl.querySelector('.wccp-next-btn');

    const compIdForNext = Number(stepEl.dataset.item_id);
    if (!STATE.selected[compIdForNext]) {
        nextBtn.disabled = true;
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            stepEl.style.display = 'none';
            goPrev(idx);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            const currentIdx = Number(stepEl.dataset.step) - 1;
            const lastStatus = isLastStep(currentIdx);

            if (!lastStatus) {
                stepEl.style.display = 'none';
                goNext(currentIdx);
            } else {
                finalizeLastStep(stepEl, currentIdx);
            }

            const compId = Number(stepEl.dataset.item_id);
            const selectedPid = STATE.selected[compId];

            const allowedSet = computeAllowedByComponent().get(compId) || new Set();

            // DEV MODE: scenario-hidden step allow navigation without selection
            if (devIgnoreHiding() && !allowedSet.size) {
                stepEl.style.display = 'none';
                goNext(idx);
                return;
            }

            if (!selectedPid) {
                nextBtn.disabled = true;
                return;
            }
            const hasDropdownForSelected = !!qs(
                `${selFor(CLASSES.option)}[data-product-id="${selectedPid}"] .wccp-variation-select`,
                stepEl
            );

            if (hasDropdownForSelected && !STATE.selectedVariants[compId]) {
                const sel = qs(
                    `${selFor(CLASSES.option)}[data-product-id="${selectedPid}"] .wccp-variation-select`,
                    stepEl
                );
                if (sel) sel.focus();
                return;
            }

            if (!isLastStep(idx)) {
                stepEl.style.display = 'none';
                goNext(idx);
            } else {
                finalizeLastStep(stepEl, idx);
            }
        });
    }

    const opts = qsa(selFor(CLASSES.option), stepEl);
    opts.forEach(opt => {
        opt.addEventListener('click', async (e) => {
            if (e.target && e.target.classList && e.target.classList.contains('wccp-variation-select')) return;

            const compId = Number(opt.dataset.componentId);
            const pid    = Number(opt.dataset.productId);

            const previousSelection = STATE.selected[compId];

            if (previousSelection !== undefined && previousSelection !== pid) {
                if (window.WCCP_SUMMARY_CLEAR) {
                    window.WCCP_SUMMARY_CLEAR(idx);
                }
            }

            opts.forEach(o => o.classList.remove(CLASSES.selected));
            opt.classList.add(CLASSES.selected);

            STATE.selected[compId] = pid;

            if (typeof renderAccessoriesStepContent === 'function') {
                const accStepEl = document.querySelector('.accessories-step');

                const accComp = (STATE.data.components || []).find(c => c.component_type === 'accessories_step');

                if (accStepEl && accComp) {
                    renderAccessoriesStepContent(accStepEl, accComp);
                }
            }

            if (window.WCCP_CONSTRUCTOR_UPDATE) {
                window.WCCP_CONSTRUCTOR_UPDATE();
            }

            if (window.WCCP_SUMMARY_UPDATE) {
                window.WCCP_SUMMARY_UPDATE();
            }

            const nextBtnLocal = stepEl.querySelector('.wccp-next-btn');
            if (nextBtnLocal) nextBtnLocal.disabled = false;
            // const compData = STATE.data.components.find(c => Number(c.id) === compId);
            // STATE.selectedQty[compId] = compData?.qty ?? 1;
            const { min_qty } = getQtyForComponent(compId, pid);
            STATE.selectedQty[compId] = min_qty;


            const sel = opt.querySelector('.wccp-variation-select');
            if (sel) {
                if (!sel.value) {
                    const first = Array.from(sel.options).find(o => o.value);
                    if (first) sel.value = first.value;
                }
                STATE.selectedVariants[compId] = sel.value ? Number(sel.value) : undefined;
            } else {
                delete STATE.selectedVariants[compId];
            }

            applyVisibilityFrom(idx);

            if (!isLastStep(idx)) {
                stepEl.style.display = 'none';
                goNext(idx);
            } else {
                await finalizeLastStep(stepEl, idx);
            }

            // DEV: Log state update on the navigation click
            // function getStateSnapshot() {
            //     return {
            //         selected: { ...STATE.selected },
            //         selectedVariants: { ...STATE.selectedVariants },
            //         selectedQty: { ...STATE.selectedQty }
            //     };
            // }


            // if (window.WCCP_DEV_MODE?.debug?.stateInfo) {
            //     console.log('state info click', STATE);
            //     window.WCCP_DEV_CONSOLE?.log("STATE_UPDATE", {
            //         source: "user_click",
            //         state: getStateSnapshot(),
            //         data: {
            //             product_id: STATE.data?.product_id,
            //             components_count: STATE.data?.components?.length || 0,
            //             scenarios_count: STATE.data?.scenarios?.length || 0,
            //             component_ids: STATE.data?.components?.map(c => c.id),
            //             scenario_ids: STATE.data?.scenarios?.map(s => s.id || s.scenario_id)
            //         }
            //     });
            // }

        });

        const sel = opt.querySelector('.wccp-variation-select');
        if (sel) {
            sel.addEventListener('change', async () => {
                const compId = Number(sel.dataset.componentId);
                const pid    = Number(sel.dataset.productId);
                STATE.selected[compId] = pid;
                STATE.selectedVariants[compId] = sel.value ? Number(sel.value) : undefined;
                if (window.WCCP_CONSTRUCTOR_UPDATE) {
                    window.WCCP_CONSTRUCTOR_UPDATE();
                }
                // DEV: Log state update
                function getStateSnapshot() {
                    return {
                        selected: { ...STATE.selected },
                        selectedVariants: { ...STATE.selectedVariants },
                        selectedQty: { ...STATE.selectedQty }
                    };
                }


                if (window.WCCP_DEV_MODE?.debug?.stateInfo) {
                    window.WCCP_DEV_CONSOLE?.log("STATE_INFO", {
                        source: "variation_change",
                        state: getStateSnapshot(),
                        data: {
                            product_id: STATE.data?.product_id,
                            components_count: STATE.data?.components?.length || 0,
                            scenarios_count: STATE.data?.scenarios?.length || 0,
                            component_ids: STATE.data?.components?.map(c => c.id),
                            scenario_ids: STATE.data?.scenarios?.map(s => s.id || s.scenario_id)
                        }
                    });
                }

                opts.forEach(o => {
                    const same = Number(o.dataset.productId) === pid;
                    same ? o.classList.add(CLASSES.selected) : o.classList.remove(CLASSES.selected);
                });

                applyVisibilityFrom(idx);

                if (isLastStep(idx)) {
                    await finalizeLastStep(stepEl, idx);
                }
            });
        }
    });


    updateStepNavButtons(stepEl);
}

function renderAccessoriesStepContent(stepEl, component) {
    if (!stepEl.querySelector('.wccp-step-nav')) {
        stepEl.innerHTML = `
      <div class="wccp-step-nav">
        <button type="button" class="wccp-step-nav__btn wccp-prev-btn">
          <span class="wccp-step-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          Previous
        </button>
        <div class="wccp-step-nav__spacer"></div>
        <button type="button" class="wccp-step-nav__btn wccp-next-btn">
          Go to Cart
          <span class="wccp-step-nav__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
        </button>
      </div>
       
      <div class="${CLASSES.stepTitleWrap}">
        <h2 class="${CLASSES.stepTitleH2}">
          <span class="${CLASSES.stepTitleText}">
            <span class="${CLASSES.stepTitle}">${component.title}</span>
          </span>
        </h2>
      </div>
      
      <div id="component_${component.id}_inner" class="${CLASSES.inner}">
        <div class="${CLASSES.selections}">
          <div class="${CLASSES.options}">
            <div class="${CLASSES.optionsInner}"></div>
          </div>
        </div>
      </div>
    `;
    }

    const optionsInner = stepEl.querySelector(selFor(CLASSES.optionsInner));
    optionsInner.innerHTML = '';

    const rules = getActiveAccessoryRules();
    const groups = component.groups || [];
    if (!STATE.selectedAccessories) STATE.selectedAccessories = {};

    groups.forEach(group => {
        if (!group.enabled || rules.hiddenGroups.has(group.id)) return;

        const hiddenInThisGroup = rules.hiddenProducts.get(group.id) || new Set();
        const visibleProducts = (group.products || []).filter(p => !hiddenInThisGroup.has(Number(p.id)));

        if (visibleProducts.length === 0) return;

        const groupHeader = document.createElement('h3');
        groupHeader.className = 'accessory-group-title';
        groupHeader.innerText = group.name;
        optionsInner.appendChild(groupHeader);

        const ul = document.createElement('ul');
        ul.className = CLASSES.ul;
        ul.style.listStyle = 'none';

        visibleProducts.forEach((prod) => {
            const min = Number(group.min ?? 0);
            const max = Number(group.max ?? 1);

            const li = document.createElement('li');
            li.className = CLASSES.li;
            li.style.display = 'block';

            const isSelected = !!STATE.selectedAccessories[prod.id];

            const currentQty = isSelected ? STATE.selectedAccessories[prod.id].qty : 0;

            const opt = document.createElement('div');

            opt.className = `${CLASSES.option} accessory-option ${isSelected ? CLASSES.selected : ''}`;
            opt.dataset.productId = String(prod.id);

            opt.innerHTML = `
              <div class="${CLASSES.imgWrap}">
                <img src="${prod.image || ''}" width="300" height="300" loading="lazy" decoding="async" alt="${(prod.title||'').replace(/"/g,'&quot;')}">
              </div>
              
              <div class="${CLASSES.nameWrap}">
                <span>${prod.title}</span>
                <div class="accessory-qty-controls">
                  <button type="button" class="qty-btn qty-minus">-</button>
                  <span class="qty-display" id="qty-val-${prod.id}">${currentQty}</span>
                  <button type="button" class="qty-btn qty-plus">+</button>
                </div>
              </div>
            `;

            const qtyControls = opt.querySelector('.accessory-qty-controls');
            const qtyDisplay = opt.querySelector('.qty-display');
            const plusBtn = opt.querySelector('.qty-plus');
            const minusBtn = opt.querySelector('.qty-minus');

            qtyControls.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            });

            const updateBtnUI = (val) => {
                minusBtn.disabled = val <= 0;
                plusBtn.disabled = val >= max;
                val <= 0 ? minusBtn.classList.add('is-disabled') : minusBtn.classList.remove('is-disabled');
                val >= max ? plusBtn.classList.add('is-disabled') : plusBtn.classList.remove('is-disabled');
            };

            updateBtnUI(currentQty);

            opt.addEventListener('click', function(e) {
                if (e.target.closest('.accessory-qty-controls')) return;

                e.preventDefault();
                e.stopImmediatePropagation();

                const isBecomingSelected = !this.classList.contains(CLASSES.selected);
                this.classList.toggle(CLASSES.selected);

                if (isBecomingSelected) {
                    let startQty = min > 0 ? min : 1;

                    qtyDisplay.innerText = startQty;
                    updateBtnUI(startQty);

                    STATE.selectedAccessories[prod.id] = {
                        groupId: group.id,
                        qty: startQty
                    };
                } else {
                    qtyDisplay.innerText = 0;
                    updateBtnUI(0);
                    delete STATE.selectedAccessories[prod.id];
                }

                updateStepNavButtons(stepEl);
                if (window.WCCP_CONSTRUCTOR_UPDATE) window.WCCP_CONSTRUCTOR_UPDATE();
            }, false);

            plusBtn.addEventListener('click', (e) => {
                let val = parseInt(qtyDisplay.innerText);

                if (val < max) {
                    if (val === 0) {
                        val = min > 0 ? min : 1;
                    } else {
                        val++;
                    }

                    qtyDisplay.innerText = val;
                    updateBtnUI(val);

                    opt.classList.add(CLASSES.selected);
                    STATE.selectedAccessories[prod.id] = {
                        groupId: group.id,
                        qty: val
                    };
                    updateStepNavButtons(stepEl);
                    if (window.WCCP_CONSTRUCTOR_UPDATE) window.WCCP_CONSTRUCTOR_UPDATE();
                }
            });

            minusBtn.addEventListener('click', (e) => {
                let val = parseInt(qtyDisplay.innerText);
                if (val > 0) {
                    if (val > min) {
                        val--;
                    } else {
                        val = 0;
                    }

                    qtyDisplay.innerText = val;
                    updateBtnUI(val);

                    if (val === 0) {
                        opt.classList.remove(CLASSES.selected);
                        delete STATE.selectedAccessories[prod.id];
                    } else if (STATE.selectedAccessories[prod.id]) {
                        STATE.selectedAccessories[prod.id].qty = val;
                    }

                    updateStepNavButtons(stepEl);
                    if (window.WCCP_CONSTRUCTOR_UPDATE) window.WCCP_CONSTRUCTOR_UPDATE();
                }
            });

            li.appendChild(opt);
            ul.appendChild(li);
        });

        optionsInner.appendChild(ul);
    });

    setTimeout(() => updateStepNavButtons(stepEl), 50);

    return stepEl;
}

    const bindStepClicks = () => {
        const steps = qsa(selFor(CLASSES.step), root);
        steps.forEach(stepEl => bindStepClicksFor(stepEl));
    };
    const applyDefaults = async () => {
        const steps = qsa(selFor(CLASSES.step), root);          // FIXED
        (STATE.data.components || []).forEach((c, i) => {
            if (c.default_product == null || Number(c.default_product) <= 0) return;

            const stepEl = steps[i];
            if (!stepEl) return;


            stepEl && ensureVariationsForStep && ensureVariationsForStep(stepEl);

            const selector = `${selFor(CLASSES.option)}[data-component-id="${c.id}"][data-product-id="${c.default_product}"]`;
            const match = qs(selector, stepEl);

            if (match) {
                // match.classList.add(CLASSES.selected);
                // STATE.selected[c.id] = Number(c.default_product);
                if (!devBlockAutoSelectSimpleForStep(stepEl)) {
                    match.classList.add(CLASSES.selected);
                    STATE.selected[c.id] = Number(c.default_product);
                } else {
                    window.WCCP_DEV_CONSOLE?.warn(
                        "AUTOSELECT_BLOCKED",
                        { source: "applyDefaults", component_id: c.id }
                    );
                }

                const sel = match.querySelector('.wccp-variation-select');
                if (sel) {
                    const first = Array.from(sel.options).find(o => o.value);
                    if (first) {
                        sel.value = first.value;
                        STATE.selectedVariants[c.id] = Number(first.value);
                    } else {
                        delete STATE.selectedVariants[c.id];
                    }
                } else {
                    delete STATE.selectedVariants[c.id];
                }
            }


        });

        applyVisibilityFrom(-1);
        const firstVisible = steps.find(s => s.style.display !== 'none') || steps[0];
        if (firstVisible) firstVisible.style.display = 'block';
        if (firstVisible) updateStepNavButtons(firstVisible);

    };